<div id="grid1ConfigDiv" class="grid-container">
  <!--Testata configurazione colonne-->
  <dx-data-grid
    id="gridConfig1"
    [allowColumnResizing]="true"
    [dataSource]="gridConf.cols"
    [rowAlternationEnabled]="true"
    [hoverStateEnabled]="true"
    [showBorders]="false"
    [showColumnLines]="true"
    [showRowLines]="true"
    (onInitNewRow)="onInitNewRow($event)"
    (onRowUpdated)="onConfigRowUpdating($event)"
    [height]="(windowSize.contentHeight ?? 0) - tabsHeight"
    (onToolbarPreparing)="hideButtons($event)"
    (onEditingStart)="saveData()"
    (onSelectionChanged)="saveData()"
  >
    <dxo-row-dragging
      [allowReordering]="true"
      [onReorder]="onReorder"
      [showDragIcons]="true"
    ></dxo-row-dragging>
    <dxi-column
      dataField="visible"
      [caption]="'Vis.' | siaTranslate"
      dataType="boolean"
      width="50px"
    ></dxi-column>
    <dxi-column
      dataField="hideOnTablets"
      [caption]="'Nascondi Ipad.' | siaTranslate"
      dataType="boolean"
      width="100px"
    ></dxi-column>
    <dxi-column
      dataField="dataField"
      [caption]="'Id' | siaTranslate"
    ></dxi-column>
    <dxi-column
      dataField="primaryKey"
      [caption]="'Pk' | siaTranslate"
      dataType="boolean"
      width="50px"
    >
      ></dxi-column
    >
    <dxi-column
      dataField="caption"
      [caption]="'Nome' | siaTranslate"
    ></dxi-column>
    <dxi-column
      dataField="dataType"
      [caption]="'Tipo' | siaTranslate"
      alignment="center"
      width="120px"
    >
      <dxo-lookup
        [dataSource]="gridConfFormatTypes"
        displayExpr="name"
        valueExpr="id"
      >
      </dxo-lookup>
    </dxi-column>
    <dxi-column
      dataField="visibleIndex"
      [caption]="'Ord.' | siaTranslate"
      dataType="number"
      alignment="center"
      sortOrder="asc"
      width="120px"
    ></dxi-column>
    <dxi-column
      dataField="width"
      [caption]="'Larghezza' | siaTranslate"
      width="100px"
      dataType="string"
    ></dxi-column>
    <dxi-column dataField="format" [caption]="'Formattazione' | siaTranslate">
    </dxi-column>
    <dxi-column
      dataField="alignment"
      [caption]="'All.' | siaTranslate"
      dataType="string"
      alignment="center"
      width="100px"
    >
      <dxo-lookup
        [dataSource]="gridConfAlignmentTypes"
        displayExpr="name"
        valueExpr="id"
      >
      </dxo-lookup>
    </dxi-column>
    <!-- <dxi-column
      dataField="hidingPriority"
      [caption]="'Priorità scomparsa' | siaTranslate"
      dataType="number"
      width="80px"
    ></dxi-column> -->
    <dxi-column
      dataField="allowEditing"
      [caption]="'Edit' | siaTranslate"
      dataType="boolean"
      width="90px"
    ></dxi-column>
    <dxi-column
      dataField="allowExporting"
      [caption]="'Esportazione' | siaTranslate"
      dataType="boolean"
      width="90px"
    ></dxi-column>
    <dxo-editing
      mode="batch"
      refreshMode="repaint"
      [allowUpdating]="true"
      [allowDeleting]="true"
      [allowAdding]="true"
      [useIcons]="true"
      [selectTextOnEditStart]="selectTextOnEditStart"
      [startEditAction]="startEditAction"
    >
    </dxo-editing>

    <dxo-selection mode="single"></dxo-selection>
    <dxo-remote-operations [sorting]="true" [paging]="true">
    </dxo-remote-operations>
    <dxo-sorting mode="multiple"></dxo-sorting>
    <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
    <dxo-load-panel [enabled]="false"></dxo-load-panel>
    <dxo-header-filter [visible]="true"></dxo-header-filter>
    <dxo-filter-row [visible]="false"></dxo-filter-row>
    <dxo-search-panel [visible]="false"></dxo-search-panel>
    <dxo-group-panel [visible]="false"></dxo-group-panel>
    <dxo-grouping #expand [autoExpandAll]="false"></dxo-grouping>
    <dxo-scrolling mode="virtual"></dxo-scrolling>

    <dxo-toolbar>
      <dxi-item name="addRowButton"></dxi-item>

      <dxi-item location="after">
        <div *dxTemplate>
          <dx-button icon="refresh" (onClick)="refreshConfiguration($event)">
          </dx-button>
        </div>
      </dxi-item>
    </dxo-toolbar>
  </dx-data-grid>
</div>
